import { api } from "..";

import { Coupon } from "@/types/ApiResponses/Coupon";
import { PaginatedResponse, QueryProps } from "@/types/Api";

interface SearchCouponsParams {
  category?: string;
  sportCategory?: string;
  type?: string;
  statusList?: string[];
  startDate?: string;
  endDate?: string;
  deleted?: boolean;
  userIds?: number[];
  subDealerIds?: number[];
  dealerIds?: number[];
  names?: string[];
  matchId?: string;
  q?: string;
  lang?: string;
  page?: number;
  pageSize?: number;
  cursor?: string;
  direction?: "first" | "next" | "prev" | "last";
}

export const getCoupons = async (
  props: QueryProps<SearchCouponsParams>
): Promise<Coupon[]> => {
  const res = await api.client.get(`/users-new/coupons/summary`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};

export interface CouponSummaryPaginationMeta {
  totalItems: number;
  itemCount: number;
  currentPage: number;
  itemsPerPage: number;
  totalPages: number;
}

export interface PaginatedCouponsSummary {
  meta: CouponSummaryPaginationMeta;
  items: Coupon[];
}

// Server-side paginated coupon summary (admin coupon-list / active-coupons).
export const getCouponsSummaryPaginated = async (
  props: QueryProps<SearchCouponsParams>
): Promise<PaginatedCouponsSummary> => {
  const res = await api.client.get(`/users-new/coupons/summary/paginated`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};

export interface KeysetCouponsSummary {
  items: Coupon[];
  total: number;
  pageSize: number;
  startCursor: string | null; // cursor of the first row (go prev)
  endCursor: string | null; // cursor of the last row (go next)
}

// Cursor (keyset) coupon summary — constant-time at any page depth.
export const getCouponsSummaryKeyset = async (
  props: QueryProps<SearchCouponsParams>
): Promise<KeysetCouponsSummary> => {
  const res = await api.client.get(`/users-new/coupons/summary/keyset`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};

export const getCouponIds = async (
  props: QueryProps<SearchCouponsParams>
): Promise<string[]> => {
  const res = await api.client.get(`/users-new/coupons/ids`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
